///
/// EarthBrowser
///
/// Migration v36 to v37: Add engagement slice
/// Created by Matt Giger on 9/13/2026
/// Copyright (c) 2026 Geodata Labs
///

/**
 * Migration: v36 to v37
 *
 * Changes:
 * - Seeds the new persisted engagement slice (anonymous session counting
 *   for the account-conversion funnel) with an empty state for existing
 *   installs. Existing users intentionally start at session zero: the
 *   funnel ladder treats unknown history as new-visitor politeness.
 */
export function migrateV36toV37(state: unknown): unknown {
	const s = state as Record<string, unknown> | null | undefined
	if (!s || typeof s !== "object") return state
	if (s.engagement) return state

	return {
		...s,
		engagement: {
			anonymousId: null,
			firstSeenAt: null,
			sessionCount: 0,
			lastSessionDay: null,
			firstSessionWasDeepLink: false,
			lastSessionWasDeepLink: false,
		},
	}
}
